import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, tap } from 'rxjs/operators';
import { publicMethods, baseUrl } from '../globals';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class QuotaManagementService {
  constructor(
    private http: HttpClient,
    private pubMethods: publicMethods,
    private auth: AuthenticationService
  ) {}

  isLoading = {
    loadingQuotaDetails: false,
    loadingTeamQuotaDetails: false,
    settingQuota: false,
  };

  getOrganisationQuotaDetails(
    featureName: string,
    quotaType: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('featureName', featureName)
      .set('quotaType', quotaType);
    this.isLoading['loadingQuotaDetails'] = true;
    return this.http
      .post(
        baseUrl + '/return_organisation_quota_details/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => (this.isLoading['loadingQuotaDetails'] = false)),
        catchError(
          this.pubMethods.handleError('getOrganisationQuotaDetails', [])
        )
      );
  }

  getTeamQuotaDetails(
    featureName: string,
    quotaType: string,
    teamId: number | string
  ): Observable<any> {
    if (!teamId) {
      teamId = '';
    }
    let params = new HttpParams()
      .set('featureName', featureName)
      .set('quotaType', quotaType)
      .set('teamId', teamId);
    this.isLoading['loadingTeamQuotaDetails'] = true;
    return this.http
      .post(
        baseUrl + '/return_team_quota_details/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => (this.isLoading['loadingTeamQuotaDetails'] = false)),
        catchError(this.pubMethods.handleError('getTeamQuotaDetails', []))
      );
  }

  getUserQuotaDetails(featureName: string, quotaType: string): Observable<any> {
    let params = new HttpParams()
      .set('featureName', featureName)
      .set('quotaType', quotaType);
    this.isLoading['loadingUserQuotaDetails'] = true;
    return this.http
      .post(
        baseUrl + '/return_user_quota_details/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => (this.isLoading['loadingUserQuotaDetails'] = false)),
        catchError(this.pubMethods.handleError('getUserQuotaDetails', []))
      );
  }

  setQuota(
    featureName: string,
    quotaType: string,
    quota: number,
    userId?: number,
    teamId?: number
  ): Observable<any> {
    let params = new HttpParams()
      .set('featureName', featureName)
      .set('quotaType', quotaType)
      .set('quota', quota.toString());

    if (userId) {
      params = params.set('userId', userId.toString());
    }
    if (teamId) {
      params = params.set('teamId', teamId.toString());
    }

    this.isLoading['settingQuota'] = true;
    return this.http
      .post(
        baseUrl + '/set_quota/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => (this.isLoading['settingQuota'] = false)),
        catchError(this.pubMethods.handleError('setQuota', []))
      );
  }

  equallyDistributeQuotas(
    featureName: string,
    quotaType: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('featureName', featureName)
      .set('quotaType', quotaType);
    this.isLoading['settingQuota'] = true;
    return this.http
      .post(
        baseUrl + '/equally_distribute_quotas_to_all_users/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => (this.isLoading['settingQuota'] = false)),
        catchError(this.pubMethods.handleError('equallyDistributeQuotas', []))
      );
  }
}
